


















































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import AppBar from "../../components/AppBar.vue";
import Footer from "../../components/Footer.vue";
import CarouselCard from "../../components/CarouselCard.vue";

window.onload = function() {
  const slider: any = document.getElementById("proposito");
  let isDown = false;
  let startX: number;
  let scrollLeft: number;
  slider.addEventListener("mousedown", (e: any) => {
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("active");
  });
  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("active");
  });
  slider.addEventListener("mousemove", (e: any) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;
    slider.scrollLeft = scrollLeft - walk;
  });
};

@Component({ components: { AppBar, Footer, CarouselCard } })
export default class Home extends Vue {
  // eslint-disable-next-line class-methods-use-this
}
